import { Component, ContentChild, EventEmitter, Input, OnChanges, OnInit, Output, TemplateRef } from '@angular/core';
import { ScApiService } from 'refs/sc-ui/services/api.service';
import { texts } from './activity-feed.texts';

@Component({
    selector: 'sc-activity-feed',
    templateUrl: './activity-feed.component.html',
    styleUrls: ['./activity-feed.component.scss'],
    standalone: false
})
export class ActivityFeedComponent implements OnInit, OnChanges {

  @ContentChild(TemplateRef)
  itemTemplate: TemplateRef<any>;

  @Input()
  user: any;

  @Input()
  pageSize = 10;

  @Input()
  readOnly = false;

  @Input()
  canLoadMore = true;

  @Input()
  uri;

  @Input()
  mentionsUri;

  @Input()
  headline: any = null;

  @Input()
  language: 'de' | 'en' = 'de';

  texts = texts;

  @Input()
  condensed = true;

  // where the feed is shown (e.g. 'candidate'), handed to the item template as `context`
  @Input()
  context: string = null;

  page = 1;

  activities: any = [];

  mentionItems: any = [];

  @Output()
  submitted = new EventEmitter<any>();

  @Output()
  itemsChanged = new EventEmitter<any>();

  // emits the clicked activity; only bound feeds make their items clickable
  @Output()
  navigate = new EventEmitter<any>();

  get isNavigable() {
    return this.navigate.observers.length > 0;
  }

  isLoading = true;

  hasMoreItems = true;

  isSending = false;

  input = '';



  constructor(private api: ScApiService) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: any) {
    if (changes.uri && changes.uri != this.uri) {
      this.reloadItems();
    }

    if (changes.mentionsUri && changes.mentionsUri != this.mentionsUri) {
      this.loadMentionItems();
    }
  }

  submit() {

    this.isSending = true;

    var activity = {
      Content: '#commented',
      Payload: {
        Body: this.input
      }
    };

    this.api.post(this.uri, activity).subscribe(d => {

      this.isSending = false;
      this.activities.splice(0, 0, d);

      if (this.activities.length >= this.pageSize)
        this.activities.splice(this.activities.length - 1, 1);
      this.input = '';

      this.itemsChanged.emit(this.activities);
    });

    this.submitted.emit(this.input);
  }

  reloadItems() {
    this.loadItems(true);
  }

  loadItems(clear = false) {

    if (!this.uri) return;

    if (clear)
    {
      this.page = 1;
    }

    this.isLoading = true;
    var page = this.page;
    var pageSize = this.pageSize;

    var uri = `${this.uri}?page=${page}&pageSize=${pageSize}`;

    this.api.get(uri).subscribe((d: any) => {
      if (clear)
      {
        this.activities = [];
      }
      
      d.Items.forEach(a => this.applySystemAuthor(a));
      this.activities.push.apply(this.activities, d.Items);
      this.isLoading = false;
      this.hasMoreItems = d.TotalCount > this.activities.length;
      this.page++;
      this.itemsChanged.emit(this.activities);
    })
  }

  // Activities without an author or a candidate come from the system and are shown as skillconomy.
  // The avatar's imageSize pipe needs an absolute URL.
  private applySystemAuthor(activity: any) {
    if (activity.Author || activity.Candidate) return;

    activity.Author = {
      FirstName: 'skillconomy',
      LastName: '',
      Image: typeof document == 'undefined' ? null : new URL('assets/icons/sc-icon.svg', document.baseURI).href
    };
  }

  loadMentionItems() {
    if (!this.mentionsUri) return;
    this.api.get(this.mentionsUri).subscribe((d: any) => {
      this.mentionItems = d;
    });
  }

}
